/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fc_Vs_Table_TitleInputs */

const en_fc_vs_table_title = /** @type {(inputs: Fc_Vs_Table_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Side by side`)
};

/**
* | output |
* | --- |
* | "Side by side" |
*
* @param {Fc_Vs_Table_TitleInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const fc_vs_table_title = /** @type {((inputs?: Fc_Vs_Table_TitleInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fc_Vs_Table_TitleInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_fc_vs_table_title(inputs)
});
export { fc_vs_table_title as "fc.vs.table.title" }